import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type RadioSelectionProps, RadioSelection } from '../RadioSelection';

type FormRadioSelectionProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  RadioSelectionProps;

function FormRadioSelection<TFieldValues extends FieldValues = FieldValues>(
  props: FormRadioSelectionProps<TFieldValues>,
) {
  const {
    field: { ref: fieldRef, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <RadioSelection
      {...props}
      {...field}
      onChange={(event, value) => {
        props.onChange?.(event, value);
        field.onChange(value);
      }}
      error={!!error}
      helperText={error?.message ?? props.helperText ?? ''}
      ref={(ref: HTMLDivElement) => {
        fieldRef({
          focus: () => ref?.scrollIntoView({ block: 'center' }),
        });
      }}
    />
  );
}

export type { FormRadioSelectionProps };
export { FormRadioSelection };
